import { render } from "./component.vue?vue&type=template&id=3927e6e3"
import script from "./component.vue?vue&type=script&setup=true&lang=js"
export * from "./component.vue?vue&type=script&setup=true&lang=js"

import "./component.vue?vue&type=style&index=0&id=3927e6e3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/plugins/page-loader/component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3927e6e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3927e6e3', __exports__)) {
    api.reload('3927e6e3', __exports__)
  }
  
  module.hot.accept("./component.vue?vue&type=template&id=3927e6e3", () => {
    api.rerender('3927e6e3', render)
  })

}


export default __exports__